import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase, SET_PASSWORD_URL } from '../supabase.js';

export default function RequestReset() {
  const [email,   setEmail]   = useState('');
  const [sent,    setSent]    = useState(false);
  const [err,     setErr]     = useState(null);
  const [pending, setPending] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null); setPending(true);
    // Supabase deliberately returns success whether or not the email is a
    // known user, so we always show the "check your inbox" state after a
    // 200. If the address isn't a portal user, nothing arrives — the hint
    // below the form covers that case.
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: SET_PASSWORD_URL,
    });
    setPending(false);
    if (error) { setErr(error.message); return; }
    setSent(true);
  }

  return (
    <div className="signin">
      <img src="/dl-logo.png" alt="Digital Lotus" className="brand-mark" />
      <h1>Reset your password</h1>

      {sent ? (
        <>
          <p>
            If <strong>{email}</strong> has a portal account, we've sent a link
            to reset your password. Open it on this device to continue.
          </p>
          <p className="hint">Didn't get it? Check spam, or ask Digital Lotus to add you.</p>
          <div style={{ height: 12 }} />
          <p className="hint"><Link to="/">← Back to sign in</Link></p>
        </>
      ) : (
        <>
          <p>Enter the email you use to sign in and we'll send you a reset link.</p>
          <form onSubmit={onSubmit}>
            <input
              type="email"
              placeholder="you@company.com"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={pending}
            />
            <button type="submit" disabled={pending || !email}>
              {pending ? 'Sending…' : 'Send reset link'}
            </button>
            {err && <p className="msg err">{err}</p>}
          </form>
          <p className="hint"><Link to="/">← Back to sign in</Link></p>
        </>
      )}
    </div>
  );
}
